import { useState } from 'react'
import { User, LogOut, Settings, Download, MapPin } from 'lucide-react'
import { useAuth } from '../../contexts/AuthContext'
import { catService } from '../../services/catService'
import UserReports from '../UserReports'
import './UserProfile.css'

function UserProfile({ onClose }) {
  const { user, profile, signOut } = useAuth()
  const [loading, setLoading] = useState(false)
  const [showReports, setShowReports] = useState(false)

  const handleSignOut = async () => {
    setLoading(true)
    try {
      await signOut()
      onClose()
    } catch (error) {
      console.error('Error signing out:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleExportData = async (format) => {
    if (!user) return

    setLoading(true)
    try {
      const data = await catService.exportUserData(user.id, format)
      
      const blob = new Blob([data], { 
        type: format === 'csv' ? 'text/csv' : 'application/json' 
      })
      
      const url = URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = `my-cat-reports.${format}`
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
      URL.revokeObjectURL(url)
    } catch (error) {
      console.error('Error exporting data:', error)
      alert('Failed to export data. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="user-profile-overlay" onClick={onClose}>
      <div className="user-profile-content" onClick={(e) => e.stopPropagation()}>
        <div className="user-profile-header">
          <div className="user-avatar">
            <User className="user-avatar-icon" />
          </div>
          <div className="user-info">
            <h3>{profile?.full_name || 'User'}</h3>
            <p>{user?.email}</p>
          </div>
        </div>

        <div className="user-profile-menu">
          <button className="profile-menu-item" disabled>
            <Settings className="menu-icon" />
            <span>Settings</span>
            <span className="coming-soon">Coming Soon</span>
          </button>

          <button
            className="profile-menu-item"
            onClick={() => setShowReports(true)}
          >
            <MapPin className="menu-icon" />
            <span>My Reports</span>
          </button>

          <div className="profile-menu-section">
            <h4>Export Data</h4>
            <button 
              className="profile-menu-item"
              onClick={() => handleExportData('json')}
              disabled={loading}
            >
              <Download className="menu-icon" />
              <span>Export as JSON</span>
            </button>

            <button 
              className="profile-menu-item"
              onClick={() => handleExportData('csv')}
              disabled={loading}
            >
              <Download className="menu-icon" />
              <span>Export as CSV</span>
            </button>
          </div>

          <button 
            className="profile-menu-item sign-out"
            onClick={handleSignOut}
            disabled={loading}
          >
            <LogOut className="menu-icon" />
            <span>{loading ? 'Signing out...' : 'Sign Out'}</span>
          </button>
        </div>
      </div>

      {showReports && (
        <UserReports onClose={() => setShowReports(false)} />
      )}
    </div>
  )
}

export default UserProfile
